import { render, staticRenderFns } from "./HomeWishlistBR.vue?vue&type=template&id=92fb6b7c&scoped=true"
import script from "./HomeWishlistBR.vue?vue&type=script&lang=js"
export * from "./HomeWishlistBR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fb6b7c",
  null
  
)

export default component.exports